"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
class HostServiceIE extends _host.HostService {
  constructor(props) {
    super(props);
  }
  addToCart(_ref) {
    var _window$Add2Basket, _window, _window$Add2Basket$ca;
    let {
      handsetProductId,
      planProductId,
      broadbandProductId
    } = _ref;
    const loader = () => new Promise(resolve => setTimeout(() => {
      resolve({
        closeModal: true
      });
    }, 2000));
    if (typeof ((_window$Add2Basket = (_window = window).Add2Basket) === null || _window$Add2Basket === void 0 ? void 0 : (_window$Add2Basket$ca = _window$Add2Basket.call(_window)) === null || _window$Add2Basket$ca === void 0 ? void 0 : _window$Add2Basket$ca.addSimOfferById) !== 'function') {
      super.addToCart({
        handsetProductId,
        planProductId,
        broadbandProductId
      });
      return loader();
    }
    if (planProductId) {
      window.Add2Basket().addSimOfferById(planProductId);
      return loader();
    }
    super.addToCart({
      handsetProductId,
      planProductId,
      broadbandProductId
    });
    return loader();
  }
}
var _default = HostServiceIE;
exports.default = _default;